import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation ConfirmTransfer($chatId: ID!, $input: ChatTransferDetails!) {
    confirmTransfer(chatId: $chatId, input: $input) {
      id
      user {
        id
        email
        phone
      }
      transfer {
        id
        customMeta
        confirmedAt
      }
    }
  }
`);
